export enum LoginState {
    LoggedIn = "loggedin",
    LoggingOut = "loggingout",
    LoggedOut = "loggedout",
    Unknown = "unknown",
    TemporaryError = "temporaryerror"
}